
// toggle product categories
$('.widget_product_categories i.toggle').click( function() {

    var parent = $(this).parents('.widget_product_categories');
    $(this).toggleClass('opened');
    $(this).parent().parent().find('ul:first').slideToggle( 400 );

    return false;
});

//  Навешиваю onchange на селекты для изменения вывода товаров в каталоге
var changeCatalogView = function(){
    top.location.href = this.selectedOptions[0].getAttribute('change_view_href');
};

var sortSelects, countSelects;

if ((sortSelects  = $('.shop-items-controls .sort  select')).length) sortSelects [0].onchange = changeCatalogView;
if ((countSelects = $('.shop-items-controls .count select')).length) countSelects[0].onchange = changeCatalogView;


// WEBPACK FOOTER //
// ./assets/javascript/productcategorypage.js